module.exports = __webpack_public_path__ + "img/hero-image-man.d6523575.jpeg";